import { getInitials } from "../../framework/utils/get-initials/get-initials.js";
import { IconChevronLeft } from "../icon/variants/IconChevronLeft.js";
import { IconMenu } from "../icon/variants/IconMenu.js";
import { Box, Flex } from "../mantine-passthroughs/index.js";
import { Avatar } from "../avatar/Avatar.js";
import { IconButton } from "../icon-button/IconButton.js";
import { useElementSize } from "../../hooks/mantine-passthroughs/index.js";
import { useMemo } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/nav-bar/NavBar.tsx
const NavBar = (props) => {
	const { logoUrl, logoStyles, username, auth, onAvatarClick, onLogoClick, onBackButtonClick, hideBackButton, AvatarAdornment, logoHeight = "48px", logoWidth = "128px" } = props;
	const showBackButton = !hideBackButton && !!onBackButtonClick;
	const showAvatar = !!onAvatarClick;
	const { t } = useTranslation("pds");
	const { width: leftWidth, ref: leftRef } = useElementSize();
	const { width: rightWidth, ref: rightRef } = useElementSize();
	const equalSideWidth = `${Math.max(leftWidth ?? 0, rightWidth ?? 0)}px`;
	const initials = useMemo(() => {
		if (!auth) return;
		if (username) return getInitials(username);
	}, [auth, username]);
	if (AvatarAdornment) return /* @__PURE__ */ jsx(AdornmentLayout, {
		initials,
		AvatarAdornment,
		...props
	});
	return /* @__PURE__ */ jsxs(Flex, {
		justify: "space-between",
		align: "center",
		p: "xxs",
		mih: "3.5rem",
		style: { width: "100%" },
		"data-testid": "app-header-container",
		children: [
			/* @__PURE__ */ jsx(Box, {
				style: { width: equalSideWidth },
				children: showBackButton ? /* @__PURE__ */ jsx(IconButton, {
					ref: leftRef,
					Icon: IconChevronLeft,
					size: "sm",
					onClick: onBackButtonClick,
					color: "primary",
					disabled: false,
					alt: t("navbar.backButton")
				}) : null
			}),
			logoUrl ? /* @__PURE__ */ jsx("img", {
				src: logoUrl,
				style: {
					width: logoWidth,
					height: logoHeight,
					cursor: onLogoClick ? "pointer" : "initial",
					...logoStyles ?? {}
				},
				alt: "navbar-logo",
				onClick: onLogoClick
			}) : null,
			/* @__PURE__ */ jsx(Box, {
				style: { width: equalSideWidth },
				children: showAvatar ? /* @__PURE__ */ jsx(Avatar, {
					ref: rightRef,
					onClick: onAvatarClick,
					size: "md",
					initials,
					AvatarIcon: initials ? void 0 : IconMenu,
					color: "primary",
					"data-testid": "navigation-bar-avatar"
				}) : null
			})
		]
	});
};
const AdornmentLayout = (props) => {
	const { logoUrl, logoStyles, onAvatarClick, onLogoClick, AvatarAdornment, initials, logoHeight = "48px", logoWidth = "128px" } = props;
	const showAvatar = !!onAvatarClick;
	return /* @__PURE__ */ jsxs(Flex, {
		justify: "space-between",
		align: "center",
		p: "xxs",
		style: { width: "100%" },
		"data-testid": "app-header-container",
		children: [logoUrl ? /* @__PURE__ */ jsx("img", {
			src: logoUrl,
			style: {
				height: logoHeight,
				width: logoWidth,
				cursor: onLogoClick ? "pointer" : "initial",
				...logoStyles ?? {}
			},
			alt: "navbar-logo",
			onClick: onLogoClick
		}) : null, /* @__PURE__ */ jsxs(Flex, {
			align: "center",
			children: [/* @__PURE__ */ jsx(AvatarAdornment, {}), showAvatar ? /* @__PURE__ */ jsx(Avatar, {
				onClick: onAvatarClick,
				size: "md",
				initials,
				AvatarIcon: initials ? void 0 : IconMenu,
				color: "primary",
				"data-testid": "navigation-bar-avatar"
			}) : null]
		})]
	});
};

//#endregion
export { NavBar };